import React, { useState, useEffect } from 'react';
import { Phone, MapPin, Menu, X, ShoppingBag } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useNavigate } from 'react-router-dom';
import { useSettings } from '../hooks/useSettings';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const { getCartCount } = useCart();
  const navigate = useNavigate();
  const settings = useSettings();
  const whatsappNumber = settings.whatsappNumber;
  const whatsappLink = `https://wa.me/6${whatsappNumber}`;
  const cartCount = getCartCount();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleCartClick = () => {
    navigate('/checkout');
  };

  const navLinks = [
    { href: '#perabot', label: 'Produk' },
    { href: '#category', label: 'Kategori' },
    { href: '#tentang', label: 'Tentang Kami' },
    { href: '#testimoni', label: 'Testimoni' },
    { href: '#lokasi', label: 'Lokasi' },
  ];

  return (
    <header className={`sticky top-0 z-40 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white'}`}>
      {/* Marquee Alert */}
      <div className="bg-gradient-to-r from-red-700 via-red-600 to-red-700 text-white py-2 overflow-hidden border-b border-red-800">
        <div className="animate-marquee whitespace-nowrap text-xs font-semibold tracking-wide">
          <span className="mx-8">🔥 HARGA CLEARANCE GUDANG! Barang eksklusif hanya tersedia di website ini sahaja — pelanggan dari seluruh Malaysia berpeluang memilikinya. Stok sangat terhad, grab sebelum habis! 🔥</span>
          <span className="mx-8">🔥 HARGA CLEARANCE GUDANG! Barang eksklusif hanya tersedia di website ini sahaja — pelanggan dari seluruh Malaysia berpeluang memilikinya. Stok sangat terhad, grab sebelum habis! 🔥</span>
        </div>
      </div>

      {/* Top Bar - Compact */}
      <div className="bg-amber-900 text-white py-1.5">
        <div className="max-w-7xl mx-auto px-4 flex justify-between items-center text-xs">
          <a href={whatsappLink} className="flex items-center gap-1.5 hover:text-amber-200 transition-colors" data-testid="header-phone">
            <Phone size={12} />
            <span>{whatsappNumber}</span>
          </a>
          <div className="flex items-center gap-1.5">
            <MapPin size={12} />
            <span>Johor, Malaysia</span>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <a href="/" className="flex items-center" data-testid="header-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/dtvdudhd_IMG_1203.png" 
              alt="Gudang Boss Ijan"
              className="h-20 md:h-24 w-auto"
            />
          </a>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-6">
            {navLinks.map((link) => (
              <a 
                key={link.href}
                href={link.href} 
                className="text-gray-600 hover:text-amber-700 text-sm font-medium transition-colors relative group"
              >
                {link.label}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-amber-500 transition-all group-hover:w-full"></span>
              </a>
            ))}
          </div>

          {/* Right Actions */}
          <div className="flex items-center gap-2">
            {/* CTA Button - Desktop */}
            <a 
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="hidden md:inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-5 py-2 rounded-lg text-sm font-semibold transition-all"
              data-testid="header-cta"
            >
              <Phone size={16} />
              Hubungi Kami
            </a>

            {/* Mobile Menu Button */}
            <button 
              className="md:hidden p-2 text-gray-700"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="Toggle menu"
              data-testid="mobile-menu-btn"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div className={`md:hidden overflow-hidden transition-all duration-300 ${isMenuOpen ? 'max-h-96 pb-4' : 'max-h-0'}`}>
          <div className="space-y-1 pt-2 border-t border-gray-100">
            {navLinks.map((link) => (
              <a 
                key={link.href}
                href={link.href} 
                className="block px-3 py-2 text-gray-700 hover:bg-amber-50 hover:text-amber-700 rounded-lg text-sm font-medium transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <a 
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-green-500 text-white px-4 py-2.5 rounded-lg text-sm font-semibold text-center mt-3"
              onClick={() => setIsMenuOpen(false)}
            >
              Hubungi Kami
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
